// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { addUserToOrganisation } from './organisationCreators';
import { addUser } from './basicCreators';
import type { ThunkAction, User } from '../../types';

export function addOrInviteUser(
  user: User,
  settings: Object,
  organisationId: number,
  context: string
): ThunkAction {
  return function(dispatch, getState) {
    const email = user.email;
    let userId;
    // Check if the user exists (via email address)
    return dispatch(checkIfUserExists(email)).then(response => {
      console.log(response);
      const { emailExists } = response.data;

      if (emailExists) {
        user = { ...user, ...response.data.user };

        // add the user to the organisation
        return dispatch(
          addUserToOrganisation(user, organisationId, settings)
        ).then(
          response => {
            userId = user.id;
            // Send notification email
            return dispatch(inviteExistingUser(userId, organisationId));
          },
          error => dispatch(APIError(error, 'Error adding or inviting user'))
        );
      } else {
        console.log('create new user');
        // Create new user
        return dispatch(addUser(user, settings, context)).then(response => {
          userId = response.data.id;
          // Send invitation email
          dispatch(inviteNewUser(userId, organisationId));
          return userId;
        });
      }
    });
  };
}

export function checkIfUserExists(email: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/user/checkEmailExists';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        email
      }
    };

    return makeAPICall(endpoint, options).then(
      response => response,
      error => dispatch(APIError(error, 'Error checking if user exists'))
    );
  };
}

export function inviteNewUser(
  newUserId: number,
  organisationId: number
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/account/invite/new/${newUserId}`;
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: {}
    };

    return makeAPICall(endpoint, options).then(
      response => response,
      error => dispatch(APIError(error, 'Error checking if user exists'))
    );
  };
}

export function inviteExistingUser(
  userId: number,
  organisationId: number
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/account/invite/existing/${userId}`;
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => userId,
      error => dispatch(APIError(error, 'Error checking if user exists'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/users/invitationCreators.js